module.exports = __webpack_public_path__ + "img/icon-prev-file.0b05b100.svg";